import axios from 'axios'
import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
import { getToken } from '@/utils/auth'
import crypto from '@/utils/crypto'

export default {
  login: function(userName, password) {
    const key = crypto.getRandomInt(1000000000000000, 9999999999999999)
    const iv = crypto.getRandomInt(1000000000000000, 9999999999999999)
    return new Promise((receive, reject) => {
      axios({
        method: 'post',
        // url: 'http://192.168.10.52:5000/api/SystemApi/UserLogin',
        url: 'https://manage.beeftochina.com.cn/api/SystemApi/UserLogin',
        headers: {
          'X-Token': getToken() || '',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': 'X-Requested-With,Content-Type',
          'Access-Control-Allow-Methods': 'PUT,POST,GET,DELETE,OPTIONS'
        },
        data: {
          MessageType: 1001,
          MessageID: btcguid(),
          Data: {
            UserName: userName,
            Password: `${key}${iv}${crypto.aesEncryptText(password, key, iv)}`
          }
        }
      }).then((res) => {
        if (res.data.IsSuccess) {
          receive(res.data)
        } else {
          reject(res.data)
        }
      }).catch((err) => {
        reject(err)
      })
    })
  },

  // login: function(userName, password) {
  //   return request({
  //     url: '/UserLogin',
  //     method: 'post',
  //     data: {
  //       MessageType: 1001,
  //       MessageID: btcguid(),
  //       Data: {
  //         UserName: userName,
  //         Password: password
  //       }
  //     }
  //   })
  // },

  signup: function(params) {
    return request({
      url: '/UserSignUp',
      method: 'post',
      data: {
        MessageType: 1002,
        MessageID: btcguid(),
        Data: {
          LoginUserName: params.username,
          Password: params.password,
          CompanyName: params.companyname,
          CompanyLocalName: params.companylocalname,
          CompanyType: params.companytype,
          ProductType: params.producttype,
          CompanyCountry: params.country,
          CompanyProvince: params.province,
          ContactPersonName: params.contactpersonname,
          ContactPersonSex: params.contactpersonsex,
          ContactPersonEnglishName: params.contactpersonenglishname,
          CompanyPhoneNumber: params.companyphone,
          CompanyFaxNumber: params.companyfax,
          ContactPersonCellPhoneNumber: params.cellphone,
          CompanyEmail: params.companyemail,
          CompanyWebSite: params.website
        }
      }
    })
  },

  getUserInfo: function(username) {
    return request({
      url: '/GetUserInfo',
      method: 'post',
      data: {
        MessageType: 1003,
        MessageID: btcguid(),
        Data: {
          LoginUserName: username
        }
      }
    })
  },

  getUserProfile: function(username) {
    return request({
      url: '/GetUserProfile',
      method: 'post',
      data: {
        MessageType: 1004,
        MessageID: btcguid(),
        Data: {
          UserID: username
        }
      }
    })
  },

  changePassword: function(params) {
    return request({
      url: '/ChangePassword',
      method: 'post',
      data: {
        MessageType: 1005,
        MessageID: btcguid(),
        Data: {
          UserID: params.userid,
          Password: params.password,
          NewPassword: params.newpassword
        }
      }
    })
  },

  updateUserInfo: function(params) {
    return request({
      url: '/UpdateUserInfo',
      method: 'post',
      data: {
        MessageType: 1006,
        MessageID: btcguid(),
        Data: {
          UserID: params.userid,
          CompanyName: params.CompanyName,
          CompanyLocalName: params.CompanyLocalName,
          CompanyType: params.CompanyType,
          ProductType: params.ProductType,
          CompanyCountry: params.CompanyCountry,
          CompanyProvince: params.CompanyProvince,
          CompanyPhoneNumber: params.CompanyPhoneNumber,
          CompanyFaxNumber: params.CompanyFaxNumber,
          CompanyEmail: params.CompanyEmail,
          CompanyWebSite: params.CompanyWebSite,
          ContactPersonName: params.ContactPersonName,
          ContactPersonSex: params.ContactPersonSex,
          ContactPersonEnglishName: params.ContactPersonEnglishName,
          ContactPersonCellPhoneNumber: params.ContactPersonCellPhoneNumber,
          NickName: params.NickName
        }
      }
    })
  },

  membershipRequest: function(params) {
    return request({
      url: '/MembershipRequest',
      method: 'post',
      data: {
        MessageType: 1007,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID,
          UserName: params.UserName,
          RequireLevel: params.RequireLevel,
          RequireType: params.RequireType,
          RequireTypeT: params.RequireTypeT,
          isCnRequire: params.isCnRequire,
          isEnRequire: params.isEnRequire
        }
      }
    })
  },

  getCaptcha: function(mobile) {
    return request({
      url: '/GetCaptcha',
      method: 'post',
      data: {
        MessageType: 1008,
        MessageID: btcguid(),
        Data: {
          Mobile: mobile
        }
      }
    })
  },

  checkCaptcha: function(params) {
    return request({
      url: '/CheckCaptcha',
      method: 'post',
      data: {
        MessageType: 1009,
        MessageID: btcguid(),
        Data: {
          Mobile: params.mobile,
          Code: params.code
        }
      }
    })
  },

  sendMail: function(params) {
    return request({
      url: '/SendMail',
      method: 'post',
      data: {
        MessageType: 1010,
        MessageID: btcguid(),
        Data: {
          Name: params.Name,
          CompanyName: params.CompanyName,
          Phone: params.Phone,
          Email: params.Email,
          Content: params.Content
        }
      }
    })
  },

  forgetPassword: function(params) {
    return request({
      url: '/ForgetPassword',
      method: 'post',
      data: {
        MessageType: 1011,
        MessageID: btcguid(),
        Data: {
          Name: params.Name,
          Email: params.Email,
          isEn: params.isEn
        }
      }
    })
  },

  resetPasswordByEmail: function(params) {
    return request({
      url: '/ResetPasswordByEmail',
      method: 'post',
      data: {
        MessageType: 1012,
        MessageID: btcguid(),
        Data: {
          NewPassword: params.NewPassword,
          LoginUserName: params.LoginUserName,
          UpdateTime: params.UpdateTime
        }
      }
    })
  },

  checkUserName: function(username) {
    return request({
      url: '/CheckUserName',
      method: 'post',
      data: {
        MessageType: 1013,
        MessageID: btcguid(),
        Data: {
          LoginUserName: username
        }
      }
    })
  },

  checkRegEmail: function(email) {
    return request({
      url: '/CheckRegEmail',
      method: 'post',
      data: {
        MessageType: 1014,
        MessageID: btcguid(),
        Data: {
          CompanyEmail: email
        }
      }
    })
  },

  getWxTicket: function() {
    return request({
      url: '/GetWxTicket',
      method: 'post',
      data: {
        MessageType: 1015,
        MessageID: btcguid(),
        Data: {}
      }
    })
  },

  checkDuplicatePhone: function(phone) {
    return request({
      url: '/CheckDuplicatePhone',
      method: 'post',
      data: {
        MessageType: 1016,
        MessageID: btcguid(),
        Data: {
          CompanyPhoneNumber: phone
        }
      }
    })
  },

  getUserProfileByToken: function(token) {
    return request({
      url: '/GetUserProfileByToken',
      method: 'post',
      data: {
        MessageType: 1017,
        MessageID: btcguid(),
        Data: {
          Token: token
        }
      }
    })
  },

  getFrontUserInfoByUserID: function(params) {
    return request({
      url: '/GetFrontUserInfoByUserID',
      method: 'post',
      data: {
        MessageType: 1018,
        MessageID: btcguid(),
        Data: {
          UserID: params.UserID
        }
      }
    })
  },

  updateUserActivityByToken: function(token) {
    return new Promise((receive, reject) => {
      axios({
        method: 'post',
        // url: 'http://192.168.10.52:5000/api/SystemApi/UpdateUserActivityByToken',
        url: 'https://manage.beeftochina.com.cn/api/SystemApi/UpdateUserActivityByToken',
        headers: {
          'X-Token': getToken() || '',
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': 'X-Requested-With,Content-Type',
          'Access-Control-Allow-Methods': 'PUT,POST,GET,DELETE,OPTIONS'
        },
        data: {
          MessageType: 1019,
          MessageID: btcguid(),
          Data: {
            Token: token
          }
        }
      }).then((res) => {
        receive(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  },

  getCaptchaImage: function() {
    return new Promise((receive, reject) => {
      axios({
        method: 'post',
        url: 'http://192.168.10.52:5000/api/SystemApi/GetCaptchaImage',
        responseType: 'blob',
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Headers': 'X-Requested-With,Content-Type',
          'Access-Control-Allow-Methods': 'PUT,POST,GET,DELETE,OPTIONS'
        },
        data: {
          MessageType: 1019,
          MessageID: btcguid(),
          Data: {
          }
        }
      }).then((res) => {
        receive(res.data)
      }).catch((err) => {
        reject(err)
      })
    })
  }

  // updateUserActivityByToken: function(token) {
  //   return request({
  //     url: '/UpdateUserActivityByToken',
  //     method: 'post',
  //     data: {
  //       MessageType: 1019,
  //       MessageID: btcguid(),
  //       Data: {
  //         Token: token
  //       }
  //     }
  //   })
  // }
}



// WEBPACK FOOTER //
// ./src/api/login.js